import { Code, FormattedDateTime, InlineStack, Icon, Text } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { isEmptyString } from '@/utils/string';
import { MetadataRow } from './metadata-row';

type Props = { result: Extract<SearchResult, { kind: 'customer' }> };

export function CustomerPreview({ result }: Props) {
  return (
    <>
      {result.other.id != null && !isEmptyString(result.other.id) ? (
        <MetadataRow label="ID">
          <Code size="xs" className="fs-mask">
            {result.other.id}
          </Code>
        </MetadataRow>
      ) : null}
      {result.other.email != null && !isEmptyString(result.other.email) ? (
        <MetadataRow label="Email">
          <Text size="xs" className="fs-mask">
            {result.other.email}
          </Text>
        </MetadataRow>
      ) : null}
      {result.other.unsubscribed != null ? (
        <MetadataRow label="Status">
          <InlineStack gap="050" alignBlock="center">
            <Icon name={result.other.unsubscribed ? 'does-not-send' : 'check-circle'} size="sm" color="secondary" />
            <Text size="xs">{result.other.unsubscribed ? 'Unsubscribed' : 'Subscribed'}</Text>
          </InlineStack>
        </MetadataRow>
      ) : null}
      {result.other.created_at != null && !isEmptyString(result.other.created_at) ? (
        <MetadataRow label="Created">
          <Text size="xs">
            <FormattedDateTime className="fs-mask" date={result.other.created_at} format="medium" />
          </Text>
        </MetadataRow>
      ) : null}
    </>
  );
}
